import React from 'react';
import Box from '../../components/Box/Box';
import { TUtils } from '../../types/TUtils';

export type TCardVariant = 'outlined' | 'filled';

export type TCard = {
  id?: string;
  as?: keyof React.JSX.IntrinsicElements;
  variant?: TCardVariant;
  children?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
} & TUtils;

const Card = ({ as = 'article', variant = 'outlined', ...rest }: TCard) => (
  <Box {...rest} modifiers={variant} as={as} name="Card" />
);

const MemoizedCard = React.memo(Card);
MemoizedCard.displayName = 'Card';

export default MemoizedCard;
